import React from 'react'
import { H2, LayoutBand, Row, Separator, usePageWidth, BillboardText, colors } from '@fs/zion-ui'
import { Trans } from 'react-i18next'
import { Link } from '@fs/zion-router'

export default function EverythingFree() {
  const atPageWidth = usePageWidth()

  return (
    <LayoutBand marginX="xl">
      <Separator size="xl" />
      <Trans
        i18nKey="eurona-pages.lohp.united-states.everything-free"
        defaults="<Heading>Everything on FamilySearch is Free</Heading><Row>Really.<Link>Discover why.</Link></Row>"
        components={{
          Heading: <Heading />,
          Row: <Row alignX="center" gutters="pico" />,
          Link: (
            <Link
              to="/whyfamilysearchfree"
              isGray
              wayfinding
              linkName="Discover why FamilySearch is free"
              target="_blank"
            />
          ),
        }}
      />
      <Separator size={atPageWidth({ default: 'xxl', lg: 'xl' })} />
    </LayoutBand>
  )
}

function Heading({ children }) {
  return (
    <BillboardText primaryColor={colors.blue70}>
      <H2 centered size="H4">
        {children}
      </H2>
    </BillboardText>
  )
}
